/* eslint-disable react-native/no-inline-styles */
import React from 'react';
import { HStack, useMediaQuery } from 'native-base';
import { get } from 'lodash';
import { colors, ProgressThumb, BorderedCard, DashedLine } from 'fmc-digital-common';
import LoanStatusStep from './LoanStatusStep';
const ProgressThumbLabelStyle = {
  display: 'flex',
  alignItems: 'center',
  alignSelf: 'stretch',
  justifyContent: 'center',
  wordWrap: 'break-word',
  maxWidth: '30px'
};
const getThumbPresentation = status => {
  switch (status) {
    case 'InProgress':
      return {
        dashedCircleStyle: {
          color: get(colors, 'blue.900', '')
        },
        innerCircleStyle: {
          bg: 'blue.900'
        },
        stepVariant: 'regularBold',
        labelVariant: 'caption13',
        labelStyle: {
          color: 'blue.900',
          ...ProgressThumbLabelStyle
        }
      };
    case 'Completed':
      return {
        innerCircleStyle: {
          bg: 'success.300'
        },
        outerCircleStyle: {
          borderColor: 'success.300'
        },
        stepVariant: 'regularBold',
        labelVariant: 'caption13',
        labelStyle: {
          color: 'success.300',
          ...ProgressThumbLabelStyle
        }
      };
    case 'InActive':
      return {
        innerCircleStyle: {
          bg: get(colors, 'lightGray.250', '')
        },
        stepVariant: 'regularBold',
        labelVariant: 'caption13',
        labelStyle: {
          color: get(colors, 'lightGray.250', ''),
          ...ProgressThumbLabelStyle
        }
      };
  }
};
const LoanStatusTracker = props => {
  const {
    loanTrackingData
  } = props;
  const [isSmallScreen] = useMediaQuery({
    maxWidth: 768
  });
  const [isExtraLargeScreen] = useMediaQuery({
    minWidth: 992
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, !isSmallScreen ? /*#__PURE__*/React.createElement(BorderedCard, {
    borderRadius: "4",
    borderWidth: "1",
    bgColor: "lightBlue.200",
    px: "4",
    py: "8",
    testID: "loan-status-tracker-root",
    alignItems: "center",
    flex: "1",
    overflowX: "auto",
    mb: 8
  }, /*#__PURE__*/React.createElement(HStack, {
    space: "1"
  }, loanTrackingData.map((item, index) => /*#__PURE__*/React.createElement(React.Fragment, {
    key: index
  }, /*#__PURE__*/React.createElement(ProgressThumb, {
    icon: item.state === 'Completed' ? 'GreenTickIcon' : '',
    thumbPresentation: getThumbPresentation(item.state),
    step: item.step,
    state: item.state,
    text: item.text
  }), index < loanTrackingData.length - 1 ? /*#__PURE__*/React.createElement(DashedLine, {
    dashColor: item.state === 'Completed' ? get(colors, 'success.300', '') : get(colors, 'lightGray.250', ''),
    dashGap: item.state === 'Completed' ? 0 : 2,
    style: {
      width: isExtraLargeScreen ? '9%' : '8%',
      marginTop: 16
    },
    testID: `status-tracker-dashed-line-${item.state}`
  }) : null)))) : /*#__PURE__*/React.createElement(LoanStatusStep, {
    loanTrackingData: loanTrackingData
  }));
};
export default /*#__PURE__*/React.memo(LoanStatusTracker);
//# sourceMappingURL=index.js.map